import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem, IonContent} from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from './TakePhoto';
import { AddSupplierModal } from './Modal_AddSupplier';

import '../css/zInternal_css.css';


export function AddEstimateModal (props) {


    let supplierNameRef = useRef('');
    let supplierPhoneRef = useRef('');
    let estimateDescriptionRef = useRef('');
    let totalEstimateAmount = useRef('');


    let [quantity_state, setQuantity_state] = useState(1);
    let [paymentType_state, setPaymentType_state] = useState('mobile_money');

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 
    let [showSupplierModal , setShowSupplierModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    let [searchResults, setSearchResults] = useState([]);

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);
    let [expenseInvoiceAttachement, setExpenseInvoiceAttachment] = useState('/var/www/web/Public/fileServer/merchants/attachment-not-available.png');

    let [disableEstimate_Button, setDisableEstimate_Button] = useState(false);


    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setExpenseInvoiceAttachment(noImageFile);

        })
    }


    function addEstimate(enteredPassword)
    {

        setDisableEstimate_Button(true);
        
        let formData = new FormData();
        formData.append('Tracker', '74002B_add_estimate');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xProjectID', props.data.projectID);
        formData.append('xSupplierName', supplierNameRef.current.value);
        formData.append('xSupplierPhoneNumber', supplierPhoneRef.current.value);
        //formData.append('xSupplierEmailAddress', supplierEmailAddressRef.current.value);
        //formData.append('xSupplierAddressNumber', supplierAddressNumberRef.current.value);
        //formData.append('xSupplierStreetName', supplierStreetNameRef.current.value);
        //formData.append('xSupplierCity', supplierCityRef.current.value);
        //formData.append('xSupplierCityDistrict', supplierCityDistrictRef.current.value);
        //formData.append('xSupplierCountryRegion', supplierCountryRegionRef.current.value);
        //formData.append('xSupplierCountry', supplierCountryRef.current.value);
        //formData.append('xSupplierDigitalAddressID', employeeDigitalAddressIDRef.current.value)
        formData.append('xEstimateDescription', estimateDescriptionRef.current.value);
        formData.append('xEstimateTotalAmount', totalEstimateAmount.current.value);
        formData.append('xEnterAdminPassword', enteredPassword);
        formData.append('sessionID', sessionID);
        formData.append('xImageFile', selectedFile);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        



       /* const requestOptions = {
            method: 'POST',
            //credentials: 'include',SS
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002B',
                user: acctID,
                xSupplierName: supplierNameRef.current.value,
                xSupplierPhoneNumber: supplierPhoneRef.current.value,
                // xSupplierEmailAddress: supplierEmailAddressRef.current.value,
                // xSupplierAddressNumber: supplierAddressNumberRef.current.value,
                // xSupplierStreetName: supplierStreetNameRef.current.value,
                // xSupplierCity: supplierCityRef.current.value,
                // xSupplierCityDistrict: supplierCityDistrictRef.current.value,
                // xSupplierCountryRegion: supplierCountryRegionRef.current.value,
                // xSupplierCountry: supplierCountryRef.current.value,
                // xSupplierDigitalAddressID: employeeDigitalAddressIDRef.current.value,
                xExpenseDescription: expenseDescriptionRef.current.value,
                xExpenseUnitAmount: unitAmountRef.current.value,
                xExpenseQuantity: quantityRef.current.value,
                xExpenseTotalAmount: totalExpenseAmount,
                xPaymentType: paymentTypeRef.current.value,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
                xSupportingDocumentation: selectedFile,

            })
        }*/

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            setDisableEstimate_Button(false);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);


    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {


        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
            Tracker = '74002S_P';

        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSupplierSearchName: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                                else if(searchCategory === 'phone')
                                {

                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                }
                            }
                    })
        }


    function selectedFileHandler(event)
    {

        /*let expenseObject = {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
            filename: event,

        }*/


        setSelectedFile(event);
       // setTakePhotoStatus(false);

    }

    function handleFileChange(event) {

        //alert('In handleFileChange');
        //alert(event);
        //alert(event.target);
        //alert(event.target.files);
        //alert(event.target.file);
        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
        //setFileName(file ? file.name : '');
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    let timeout;

    function handleInput(event) {

        document.getElementById('searchSupplierNameList').innerHTML = '';
        document.getElementById('searchSupplierPhoneNumberList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout
    
    }


    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <IonContent className='bookedDetails_gridContent_multiple'>
                    <IonSlides pager='true' className='custom-pagination' options={{ speed: 100 }}>

                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <label for='searchSupplierName'>Supplier Name:</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierName' ref={ supplierNameRef } placeholder='Search supplier name' onInput={() => handleInput(['name', supplierNameRef.current.value])} list='searchSupplierNameList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierNameList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierName}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <label for='searchSupplierPhoneNumber'>Supplier Phone Number:</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierPhoneNumber' ref={ supplierPhoneRef }  placeholder='Search supplier phone number' onInput={() => handleInput(['phone', supplierPhoneRef.current.value])} list='searchSupplierPhoneNumberList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierPhoneNumberList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierPhoneNumber}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                    </IonRow>
                                    {/*<IonRow>
                                        <IonCol>
                                            <IonButton  onClick={() => setShowSupplierModal(true)}> Add Supplier</IonButton>
                                        </IonCol>
                                    </IonRow>*/}
                                </IonGrid>

                            <AddSupplierModal  openModal={ showSupplierModal } closeModal={() => setShowSupplierModal(false)}></AddSupplierModal>
                        </IonSlide>
                        {/*<IonSlide>
                            <IonItem>
                                <IonLabel>Supplier City District: </IonLabel>
                                <IonInput placeholder='Enter Digital Address' ref={ employeeDigitalAddressIDRef }></IonInput>
                            </IonItem>
                        </IonSlide>
                        <IonSlide>
                            <IonItem>
                                <IonLabel>Supplier Digital Address ID: </IonLabel>
                                <IonInput placeholder='Enter Digital Address' ref={ employeeDigitalAddressIDRef }></IonInput>
                            </IonItem>
                        </IonSlide>*/}
                        <IonSlide>
                                <IonGrid  className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Estimate Description: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='text' placeholder='Enter Description' ref={ estimateDescriptionRef }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Total Cost: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='text' placeholder='Enter Amount' ref={ totalEstimateAmount }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                        {/*<IonSlide >
                                <IonGrid class='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Quantity: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='number' placeholder='Enter Qty' ref={ quantityRef }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                        <IonSlide>
                                <IonGrid class='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel for="employeeRole">Payment Type </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <select name="employeeRole" id='employeeRole' ref={paymentTypeRef }>
                                                <option value='cash'>Cash</option>
                                                <option value='mobile_money' selected>Mobile Money</option>
                                            </select>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>*/}
                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>                            
                                            <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>
                                            {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                                        </IonCol>
                                        <IonCol>
                                            <input
                                                type="file"
                                                accept="image/jpeg"
                                                onChange={handleFileChange}
                                            />
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <label for='noAttachment'>No Attachment</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement()}></input>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton id='gridResultColumnButton'  disabled={disableEstimate_Button}  onClick={() => addEstimate()}> Add Estimate </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                    </IonSlides>
                    
                    <IonButton className='button_closeModal_center' onClick={() => closeModalHandler(false)}>Cancel </IonButton>

                        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}                        
                        {/*<IonButton onClick={() => setShowPasswordModal(true)}> Add Expense </IonButton>*/}
                        </IonContent>
                    </IonModal>) : null
                }
            </React.Fragment>

    )
}